var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVeryHigh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56.92 56.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff8f99;}.cls-2{fill:none;stroke:#231f20;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 28.46,
    cy: 28.46,
    r: 28.46
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "13.75 18.88 19.28 21.71 14.43 24"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "43.28 18.88 37.75 21.71 42.61 24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.37,32.77s2.56,4.45,4.85,0,5,1.79,7.56,2,3.1-4.4,5.79-4.53,2.3,4.1,4.72,4.54,3.51-1,3.64-2.27"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeryHigh);
export default __webpack_public_path__ + "static/media/very-high.65d3ce3eb31f890c0fbefdea8774fef0.svg";
export { ForwardRef as ReactComponent };